import { Component, Input, OnInit } from '@angular/core';
import { Validators } from '@angular/forms';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { Comprobante } from 'app/dto/comprobante.dto';
import { TipoComprobante } from 'app/dto/tipo-comprobante.dto';
import { FieldConfig } from 'app/genericForm/field.interface';
import { TipoComprobanteService } from 'app/service/tipo-comprobante.service';

@Component({
  selector: 'app-modal-abm-comprobante',
  templateUrl: './modal-abm-comprobante.component.html',
  styleUrls: ['./modal-abm-comprobante.component.scss'],
})
export class ModalABMComprobanteComponent implements OnInit {

  formComprobante: FieldConfig[]
  tiposComprobante: TipoComprobante[];
  tiposCodigoAutorizacion = [{ valor: "CAE", display: "CAE" }, { valor: "CAI", display: "CAI" }];
  tiposDocumento = [{ valor: "DNI", display: "DNI" }, { valor: "CI", display: "CI" }, { valor: "PASAPORTE", display: "PASAPORTE" }];


  @Input() public modalRef: NgbModalRef;
  @Input() public comprobanteExistente: Comprobante;

  constructor(private tipoComprobanteService: TipoComprobanteService, private activeModal: NgbModal) {
  }

  async ngOnInit() {
    this.tiposComprobante = await this.tipoComprobanteService.findAll().toPromise();
    this.formComprobante = [
      {
        type: "separador",
        label: "Datos del Comprobante",
        claseGrillaBootstrap: "col-12"
      },
      {
        type: "select",
        label: "Tipo de Comprobante",
        name: "tipo",
        description: "display",
        id: "idTipoComprobante",
        claseGrillaBootstrap: "col-4",
        options: this.tiposComprobante
      },
      {
        type: "input",
        label: "Punto de Venta",
        inputType: "text",
        name: "puntoDeVenta",
        claseGrillaBootstrap: "col-4",
        validations: [
          {
            name: "required",
            validator: Validators.required,
            message: "Name Required"
          }
        ]
      },
      {
        type: "input",
        label: "Numero de Comprobante",
        inputType: "text",
        name: "numero",
        claseGrillaBootstrap: "col-4",
        validations: [
          {
            name: "required",
            validator: Validators.required,
            message: "Name Required"
          }
        ]
      },
      {
        type: "date",
        label: "Fecha de Emisión",
        name: "fechaEmision",
        claseGrillaBootstrap: "col-4",
        validations: [
          {
            name: "required",
            validator: Validators.required,
            message: "Name Required"
          }
        ]
      },
      {
        type: "select",
        label: "Tipo Código de Autorización",
        name: "tipoCodigoAutorizacion",
        description: "display",
        id: "valor",
        claseGrillaBootstrap: "col-4",
        options: this.tiposCodigoAutorizacion
      },
      {
        type: "input",
        label: "Código de Autorización",
        inputType: "text",
        name: "codigoAutorizacion",
        claseGrillaBootstrap: "col-4",
        validations: [
          {
            name: "required",
            validator: Validators.required,
            message: "Name Required"
          }
        ]
      },
      {
        type: "date",
        label: "Inicio de Actividades",
        name: "inicioActividades",
        claseGrillaBootstrap: "col-4",
        validations: [
          {
            name: "required",
            validator: Validators.required,
            message: "Name Required"
          }
        ]
      },
      {
        type: "input",
        label: "Código de Barras",
        inputType: "text",
        name: "codigoBarras",
        claseGrillaBootstrap: "col-5"
      },
      {
        type: "input",
        label: "Importe",
        inputType: "number",
        name: "importe",
        claseGrillaBootstrap: "col-3"
      },
      {
        type: "separador",
        label: "Datos del emisor",
        claseGrillaBootstrap: "col-12 mt-2"
      },
      {
        type: "input",
        label: "Razón Social",
        inputType: "text",
        name: "emisorRazonSocial",
        claseGrillaBootstrap: "col-6",
        validations: [
          {
            name: "required",
            validator: Validators.required,
            message: "Name Required"
          }
        ]
      },
      {
        type: "select",
        label: "Tipo de Documento",
        name: "emisorTipoDocumento",
        description: "display",
        id: "valor",
        claseGrillaBootstrap: "col-2",
        options: this.tiposDocumento
      },
      {
        type: "input",
        label: "Número de Documento",
        inputType: "text",
        name: "emisorNumeroDocumento",
        claseGrillaBootstrap: "col-4",
        validations: [
          {
            name: "required",
            validator: Validators.required,
            message: "Name Required"
          }
        ]
      },
      {
        type: "input",
        label: "Condición frente al IVA",
        inputType: "text",
        name: "emisorCondicionFrenteAlIva",
        claseGrillaBootstrap: "col-4",
        validations: [
          {
            name: "required",
            validator: Validators.required,
            message: "Name Required"
          }
        ]
      },
      {
        type: "input",
        label: "Domicilio Comercial",
        inputType: "text",
        name: "emisorDomiclioComercial",
        claseGrillaBootstrap: "col-8",
        validations: [
          {
            name: "required",
            validator: Validators.required,
            message: "Name Required"
          }
        ]
      },
      {
        type: "separador",
        label: "Datos del receptor",
        claseGrillaBootstrap: "col-12 mt-2"
      },
      {
        type: "input",
        label: "Razón Social",
        inputType: "text",
        name: "receptorRazonSocial",
        claseGrillaBootstrap: "col-6",
        validations: [
          {
            name: "required",
            validator: Validators.required,
            message: "Name Required"
          }
        ]
      },
      {
        type: "select",
        label: "Tipo de Documento",
        name: "receptorTipoDocumento",
        description: "display",
        id: "valor",
        claseGrillaBootstrap: "col-2",
        options: this.tiposDocumento
      },
      {
        type: "input",
        label: "Número de Documento",
        inputType: "text",
        name: "receptorNumeroDocumento",
        claseGrillaBootstrap: "col-4",
        validations: [
          {
            name: "required",
            validator: Validators.required,
            message: "Name Required"
          }
        ]
      },
      {
        type: "input",
        label: "Condición frente al IVA",
        inputType: "text",
        name: "receptorCondicionFrenteAlIva",
        claseGrillaBootstrap: "col-3",
        validations: [
          {
            name: "required",
            validator: Validators.required,
            message: "Name Required"
          }
        ]
      },
      {
        type: "input",
        label: "Condición de Venta",
        inputType: "text",
        name: "receptorCondicionDeVenta",
        claseGrillaBootstrap: "col-3",
        validations: [
          {
            name: "required",
            validator: Validators.required,
            message: "Name Required"
          }
        ]
      },
      {
        type: "input",
        label: "Domicilio",
        inputType: "text",
        name: "receptorDomicilio",
        claseGrillaBootstrap: "col-6",
        validations: [
          {
            name: "required",
            validator: Validators.required,
            message: "Name Required"
          }
        ]
      },
      {
        type: "espacioEnBlanco",
        claseGrillaBootstrap: "col"
      },
      {
        type: "submit",
        label: "Guardar comprobante",
        claseGrillaBootstrap: "col-auto float-right"
      }
    ];

    if (this.comprobanteExistente) {
      this.llenarValuesDelFormulario(this.comprobanteExistente);
    }
  }

  guardarComprobante(formulario: any) {
    this.modalRef.close(formulario);
  }

  llenarValuesDelFormulario(comprobante: Comprobante) {
    this.formComprobante = [
      {
        type: "separador",
        label: "Datos del Comprobante",
        claseGrillaBootstrap: "col-12"
      },
      {
        type: "select",
        label: "Tipo de Comprobante",
        name: "tipo",
        description: "display",
        id: "idTipoComprobante",
        claseGrillaBootstrap: "col-4",
        options: this.tiposComprobante,
        value: comprobante.tipo
      },
      {
        type: "input",
        label: "Punto de Venta",
        inputType: "text",
        name: "puntoDeVenta",
        claseGrillaBootstrap: "col-4",
        value: comprobante.puntoDeVenta,
        validations: [
          {
            name: "required",
            validator: Validators.required,
            message: "Name Required"
          }
        ]
      },
      {
        type: "input",
        label: "Numero de Comprobante",
        inputType: "text",
        name: "numero",
        claseGrillaBootstrap: "col-4",
        value: comprobante.numero,
        validations: [
          {
            name: "required",
            validator: Validators.required,
            message: "Name Required"
          }
        ]
      },
      {
        type: "date",
        label: "Fecha de Emisión",
        name: "fechaEmision",
        claseGrillaBootstrap: "col-4",
        value: comprobante.fechaEmision,
        validations: [
          {
            name: "required",
            validator: Validators.required,
            message: "Name Required"
          }
        ]
      },
      {
        type: "select",
        label: "Tipo Código de Autorización",
        name: "tipoCodigoAutorizacion",
        description: "display",
        id: "valor",
        claseGrillaBootstrap: "col-4",
        value: comprobante.tipoCodigoAutorizacion,
        options: this.tiposCodigoAutorizacion
      },
      {
        type: "input",
        label: "Código de Autorización",
        inputType: "text",
        name: "codigoAutorizacion",
        claseGrillaBootstrap: "col-4",
        value: comprobante.codigoAutorizacion,
        validations: [
          {
            name: "required",
            validator: Validators.required,
            message: "Name Required"
          }
        ]
      },
      {
        type: "date",
        label: "Inicio de Actividades",
        name: "inicioActividades",
        claseGrillaBootstrap: "col-4",
        value: comprobante.inicioActividades,
        validations: [
          {
            name: "required",
            validator: Validators.required,
            message: "Name Required"
          }
        ]
      },
      {
        type: "input",
        label: "Código de Barras",
        inputType: "text",
        name: "codigoBarras",
        value: comprobante.codigoBarras,
        claseGrillaBootstrap: "col-5"
      },
      {
        type: "input",
        label: "Importe",
        inputType: "number",
        name: "importe",
        value: comprobante.importe,
        claseGrillaBootstrap: "col-3"
      },
      {
        type: "separador",
        label: "Datos del emisor",
        claseGrillaBootstrap: "col-12 mt-2"
      },
      {
        type: "input",
        label: "Razón Social",
        inputType: "text",
        name: "emisorRazonSocial",
        claseGrillaBootstrap: "col-6",
        value: comprobante.emisorRazonSocial,
        validations: [
          {
            name: "required",
            validator: Validators.required,
            message: "Name Required"
          }
        ]
      },
      {
        type: "select",
        label: "Tipo de Documento",
        name: "emisorTipoDocumento",
        description: "display",
        id: "valor",
        claseGrillaBootstrap: "col-2",
        value: comprobante.emisorTipoDocumento,
        options: this.tiposDocumento
      },
      {
        type: "input",
        label: "Número de Documento",
        inputType: "text",
        name: "emisorNumeroDocumento",
        claseGrillaBootstrap: "col-4",
        value: comprobante.emisorNumeroDocumento,
        validations: [
          {
            name: "required",
            validator: Validators.required,
            message: "Name Required"
          }
        ]
      },
      {
        type: "input",
        label: "Condición frente al IVA",
        inputType: "text",
        name: "emisorCondicionFrenteAlIva",
        claseGrillaBootstrap: "col-4",
        value: comprobante.emisorCondicionFrenteAlIva,
        validations: [
          {
            name: "required",
            validator: Validators.required,
            message: "Name Required"
          }
        ]
      },
      {
        type: "input",
        label: "Domicilio Comercial",
        inputType: "text",
        name: "emisorDomiclioComercial",
        claseGrillaBootstrap: "col-8",
        value: comprobante.emisorDomiclioComercial,
        validations: [
          {
            name: "required",
            validator: Validators.required,
            message: "Name Required"
          }
        ]
      },
      {
        type: "separador",
        label: "Datos del receptor",
        claseGrillaBootstrap: "col-12 mt-2"
      },
      {
        type: "input",
        label: "Razón Social",
        inputType: "text",
        name: "receptorRazonSocial",
        claseGrillaBootstrap: "col-6",
        value: comprobante.receptorRazonSocial,
        validations: [
          {
            name: "required",
            validator: Validators.required,
            message: "Name Required"
          }
        ]
      },
      {
        type: "select",
        label: "Tipo de Documento",
        name: "receptorTipoDocumento",
        description: "display",
        id: "valor",
        claseGrillaBootstrap: "col-2",
        value: comprobante.receptorTipoDocumento,
        options: this.tiposDocumento
      },
      {
        type: "input",
        label: "Número de Documento",
        inputType: "text",
        name: "receptorNumeroDocumento",
        claseGrillaBootstrap: "col-4",
        value: comprobante.receptorNumeroDocumento,
        validations: [
          {
            name: "required",
            validator: Validators.required,
            message: "Name Required"
          }
        ]
      },
      {
        type: "input",
        label: "Condición frente al IVA",
        inputType: "text",
        name: "receptorCondicionFrenteAlIva",
        claseGrillaBootstrap: "col-3",
        value: comprobante.receptorCondicionFrenteAlIva,
        validations: [
          {
            name: "required",
            validator: Validators.required,
            message: "Name Required"
          }
        ]
      },
      {
        type: "input",
        label: "Condición de Venta",
        inputType: "text",
        name: "receptorCondicionDeVenta",
        claseGrillaBootstrap: "col-3",
        value: comprobante.receptorCondicionDeVenta,
        validations: [
          {
            name: "required",
            validator: Validators.required,
            message: "Name Required"
          }
        ]
      },
      {
        type: "input",
        label: "Domicilio",
        inputType: "text",
        name: "receptorDomicilio",
        claseGrillaBootstrap: "col-6",
        value: comprobante.receptorDomicilio,
        validations: [
          {
            name: "required",
            validator: Validators.required,
            message: "Name Required"
          }
        ]
      },
      {
        type: "espacioEnBlanco",
        claseGrillaBootstrap: "col"
      },
      {
        type: "submit",
        label: "Guardar comprobante",
        claseGrillaBootstrap: "col-auto float-right"
      }
    ];
  }
}

